
import {of as observableOf, Observable, BehaviorSubject} from 'rxjs';
import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import {NbAuthJWTToken, NbAuthService} from '@nebular/auth';
import {RESTService} from '../../services/rest.service';

// Models
import {User} from '../../models/user.model';

@Injectable()
export class UserService extends RESTService<User> {
  private userArray: any[];
  public currentUser: User;
  public sentinelToken: string;
  public selectedUser: User;
  public _currentUser: BehaviorSubject<User> = new BehaviorSubject(null);
  public _sentinelToken: BehaviorSubject<string> = new BehaviorSubject(null);;

  constructor(_http: HttpClient, authService: NbAuthService) {
    super(_http, authService);

    this.authService.onTokenChange()
    .subscribe((token: NbAuthJWTToken) => {
      if (token.isValid()) {
        const tokenPayload = token.getPayload();
        this.setCurrentUser(tokenPayload.id);
      }
    });
  }

  public setCurrentUser(currentUserId: number): void {
    this.getUserById(currentUserId).then(user => {
      this.currentUser = user;

      const data = {
        email: user.email,
        fullName: user.fullName,
        id: user.id,
        isActive: user.isActive,
        isAdmin: user.isAdmin,
        Companies: user.Companies,
      }

      localStorage.setItem('user', JSON.stringify(data))
      this._currentUser.next(user);
    });
  }

  public getUser(): Observable<User> {
    return observableOf(this.currentUser);
  }

  // GET /users
  public getAllUsers(): Promise<User[]> {
    this.setApiEndpoint('/users');
    return this.getAll();
  }

  // POST /users
  public createUser(data): Promise<User> {
    this.setApiEndpoint('/users');
    return this.save(data);
  }

  // GET /users/logout
  public logout(): Promise<any> {
    this.setApiEndpoint('/users/logout');

    return new Promise(resolve => {
      const url: string = this.apiURL;
      const headers: HttpHeaders = new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: this.authToken,
      });
      const options = {headers: headers};

      this.http.get(url, options).subscribe(
        result => {
          resolve(result);
          this._currentUser.next(null);
        },
        error => {
          throw new Error(error);
        },
      );
    });
  }

  // DELETE users/{userid}
  public deleteUser(userId: number): Promise<boolean> {
    if (userId === this.currentUser.id) {
      throw new Error('Can´t delete current user!');
    } else {
      this.setApiEndpoint('/users');
      return this.delete(userId);
    }
  }

  // GET users/{userid}
  public getUserById(id: number): Promise<User> {
    this.setApiEndpoint('/users');
    return this.get(id);
  }

  // GET project/{projectid}
  public getUserProjects(id: number): Promise<User> {
    this.setApiEndpoint('/userproject/users/project');
    return this.get(id);
  }

  // PUT users/{userid}
  public updateUser(
    userId = this.selectedUser.id,
    data: any,
  ): Promise<Boolean> {
    this.setApiEndpoint('/users');
    const object = {
      id: data.id,
      fullName: data.fullName,
      position: data.position,
      profileImg: data.profileImg,
      isActive: data.isActive,
    };
    return this.update(object);
  }

  // Create new User
  public newResource(data: any): User {
    return new User(this, data);
  }

  public setSelectedUser(user) {
    this.selectedUser = user;
  }

  public getSelectedUser() {
    return observableOf(this.selectedUser);
  }

  public getToken() {
    return this.authToken;
  }
}
